import { render } from "./post.vue?vue&type=template&id=9a2e70ac"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"

import "./post.vue?vue&type=style&index=0&id=9a2e70ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__